import { createContext, useContext, useState } from "react";

export interface IContact {
  id: number;
  name: string;
  phone: string;
  description: string;
  updated_at: string;
  created_at: string;
}

export interface IContactsContext {
  newContactOpen: boolean;
  setNewContactOpen: (payload: boolean) => void;
  onCloseNewContact: () => void;
  newFileContacts: boolean;
  setNewFileContacts: (payload: boolean) => void;
  onCloseNewFileContact: () => void;
  currentContact: null | IContact;
  setCurrentContact: (payload: IContact | null) => void;
  contactReload: boolean;
  setContactReload: (payload: boolean) => void;
}

const contactsContext = createContext<IContactsContext>({
  newContactOpen: false,
  setNewContactOpen: () => false,
  onCloseNewContact: () => false,
  newFileContacts: false,
  onCloseNewFileContact: () => false,
  setNewFileContacts: () => false,
  currentContact: null,
  setCurrentContact: (payload: IContact | null) => false,
  contactReload: false,
  setContactReload: (payload: boolean) => false,
});

export function ContactsContextProvider(props: any) {
  const [newFileContacts, setNewFileContacts] = useState<boolean>(false);
  const [newContactOpen, setNewContactOpen] = useState(false);
  const [currentContact, setCurrentContact] = useState(null);
  const [contactReload, setContactReload] = useState(false);

  const onCloseNewContact = () => setNewContactOpen(false);
  const onCloseNewFileContact = () => setNewFileContacts(false);

  return (
    <contactsContext.Provider
      value={{
        newContactOpen,
        setNewContactOpen,
        onCloseNewContact,
        newFileContacts,
        setNewFileContacts,
        onCloseNewFileContact,
        currentContact,
        setCurrentContact,
        contactReload,
        setContactReload,
      }}
      {...props}
    />
  );
}

export const useContactsContext = () => useContext(contactsContext);
